// A required document is stored as { "<Document name>": "" | "<file url>", Time: hours, Reminder_details: { recipient: hours } }.
const META_KEYS = ['Time', 'Reminder_details', 'Remind_before', 'esitmated_time', 'estimated_time'];

export const docName = (doc) => Object.keys(doc).find((k) => !META_KEYS.includes(k)) || '';
export const docFile = (doc) => doc[docName(doc)] || '';
export const docDue = (doc) => doc.estimated_time || doc.esitmated_time || '';

export const UNITS = [
  { value: 'hours', label: 'Hours', factor: 1 },
  { value: 'days', label: 'Days', factor: 24 },
  { value: 'months', label: 'Months', factor: 720 },
];
export const toHours = (amount, unit) => Math.round(Number(amount) * UNITS.find((u) => u.value === unit).factor);

export const MAX_HOURS = 24 * 365;

/** Hours as the largest whole unit that fits, for editing: 48 -> { amount: '2', unit: 'days' }. */
export function splitHours(hours) {
  const h = Number(hours);
  if (h > 0 && h % 720 === 0) return { amount: String(h / 720), unit: 'months' };
  if (h > 0 && h % 24 === 0) return { amount: String(h / 24), unit: 'days' };
  return { amount: h > 0 ? String(h) : '', unit: 'hours' };
}

/** A message when an amount and unit are not a usable time span (whole number, at least 1 hour, at most a year), else ''. */
export function spanError(amount, unit) {
  const n = Number(amount);
  if (String(amount).trim() === '' || !(n > 0)) return 'Enter a number above 0.';
  if (!Number.isInteger(n)) return 'Use a whole number.';
  return toHours(n, unit) > MAX_HOURS ? 'At most one year.' : '';
}

export function describeHours(hours) {
  const h = Number(hours);
  if (!h) return '—';
  if (h % 720 === 0) return `${h / 720} month${h / 720 > 1 ? 's' : ''}`;
  if (h % 24 === 0) return `${h / 24} day${h / 24 > 1 ? 's' : ''}`;
  return `${h} hour${h > 1 ? 's' : ''}`;
}

export const newDoc = (name, hours, before) => ({ [name.trim()]: '', Time: hours, Reminder_details: {}, ...(before ? { Remind_before: before } : {}) });

/** Why a "remind before due" time is unusable (blank is fine: no heads-up), else ''. */
export function beforeError(amount, unit, dueHours) {
  if (String(amount).trim() === '') return '';
  return spanError(amount, unit) || (toHours(amount, unit) >= dueHours ? 'Must be shorter than the due time.' : '');
}

// Uploads: one file, at most 10 MB, as a PDF, an image or a Word document. The server applies the same limits.
export const UPLOAD_TYPES = ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx'];
export const UPLOAD_MAX_MB = 10;
export function checkUpload(file) {
  const ext = file.name.includes('.') ? file.name.split('.').pop().toLowerCase() : '';
  if (!UPLOAD_TYPES.includes(ext)) return 'Upload a PDF, an image (PNG or JPG) or a Word document.';
  if (file.size === 0) return 'The file is empty.';
  if (file.size > UPLOAD_MAX_MB * 1024 * 1024) return 'The file is larger than ' + UPLOAD_MAX_MB + ' MB.';
  return '';
}

